const utilList = () => import('@/pages/device/util/index.vue');
// const deviceDetail = () => import('@/pages/device/list/detail.vue');

export default [{
    path: '/device/util',
    component: utilList,
    meta: [{
        name: '设备管理'
    },
    {
        name: '配件列表',
        activeRoute: '/device/util'
    }]
}];